import React from 'react';
import { ObjectWrapper } from './styles/Common.styles';
import { StyledButton } from './styles/Button.styles';
import {
  SignatureWrapper,
  SignaturePad,
  SignatureButtonContainer
} from './styles/WebSignature.styles';

const WebSignatureControl = ({ control }) => {

  const isButtonsOnTop = control.buttonPosition === 'checked';
  return (
    <ObjectWrapper>
      <SignatureWrapper>
        <SignaturePad styleProps={control.attributes} />
        <SignatureButtonContainer isButtonsOnTop={isButtonsOnTop}>
          <StyledButton styleProps={control.attributes}>
            {control.saveLabel}
          </StyledButton>
          <StyledButton styleProps={control.attributes}>
            {control.clearLabel}
          </StyledButton>
        </SignatureButtonContainer>
      </SignatureWrapper>
    </ObjectWrapper>
  );
}

export default WebSignatureControl;